import { HttpStatus } from '../types';
import { AppError, ErrorTypes } from './app.error';

export class NotFoundError extends AppError {
    constructor(detail?: string, rest?: { [key: string]: unknown }) {
        super({
            status: HttpStatus.NOT_FOUND,
            type: ErrorTypes.RESOURCE_NOT_FOUND,
            title: 'Not Found',
            detail,
            ...rest,
        });
    }
}
